export default "__VITE_ASSET__CtqrWWoy__"